/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Status_OfferInputs */

const en_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer`)
};

const de_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebot`)
};

const fr_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offre`)
};

const es_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta`)
};

const it_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerta`)
};

const nl_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbod`)
};

const pl_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferta`)
};

const fi_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjous`)
};

const da_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbud`)
};

const sv_jobs_status_offer = /** @type {(inputs: Jobs_Status_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudande`)
};

/**
* | output |
* | --- |
* | "Offer" |
*
* @param {Jobs_Status_OfferInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_status_offer = /** @type {((inputs?: Jobs_Status_OfferInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Status_OfferInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_status_offer(inputs)
	if (locale === "fr") return fr_jobs_status_offer(inputs)
	if (locale === "es") return es_jobs_status_offer(inputs)
	if (locale === "it") return it_jobs_status_offer(inputs)
	if (locale === "nl") return nl_jobs_status_offer(inputs)
	if (locale === "pl") return pl_jobs_status_offer(inputs)
	if (locale === "fi") return fi_jobs_status_offer(inputs)
	if (locale === "da") return da_jobs_status_offer(inputs)
	if (locale === "sv") return sv_jobs_status_offer(inputs)
	return en_jobs_status_offer(inputs)
});